import http from '@/http'
import apiUrl from '@/config'

const state = {
  mywarehouses: [],
  mywarehousesAdded: [],
  mywarehousesStock: [],
  billTo: [],
  billToAdded: [],
  billToNewreturn: [],
  payTo: [],
  payOverseasTo: [],
  personnel: [],
  partners: []
}

const getters = {
  getMywarehouses: (state) => {
    return state.mywarehouses
  },
  getMywarehousesAdded: (state) => {
    return state.mywarehousesAdded
  },
  getMywarehousesStock: (state) => {
    return state.mywarehousesStock
  },
  getBillTo: (state) => {
    return state.billTo
  },
  getBillToAdded: (state) => {
    return state.billToAdded
  },
  getBillToNewreturn: (state) => {
    return state.billToNewreturn
  },
  getPayTo: (state) => {
    return state.payTo
  },
  getPayOverseasTo: (state) => {
    return state.payOverseasTo
  },
  getPersonnel: (state) => {
    return state.personnel
  },
  getPartners: (state) => {
    return state.partners
  }
}

const mutations = {
  SET_MYWAREHOUSES (state, data) {
    state.mywarehouses = data.mywarehouses
  },
  SET_MYWAREHOUSESADDED (state, data) {
    state.mywarehousesAdded = data.mywarehousesAdded
    state.mywarehousesAdded.unshift({ id: -1, name: '委託先倉庫' })
  },
  SET_MYWAREHOUSESSTOCK (state, data) {
    state.mywarehousesStock = data.mywarehousesStock
    state.mywarehousesStock.unshift({ id: -1, name: 'すべての委託倉庫' })
    state.mywarehousesStock.unshift({ id: -2, name: '総在庫' })
  },
  SET_BILLTO (state, data) {
    state.billTo = data.billTo
  },
  SET_BILLTOADDED (state, data) {
    state.billToAdded = data.billToAdded
    state.billToAdded.unshift({ id: -2, name: 'お客様交換用（不良品破棄）' })
    state.billToAdded.unshift({ id: -1, name: '自社返品' })
  },
  SET_BILLTONEWRETURN (state, data) {
    state.billToNewreturn = data.billToNewreturn
    state.billToNewreturn.unshift({ id: -1, name: '自社返品' })
  },
  SET_PAYTO (state, data) {
    state.payTo = data.payTo
  },
  SET_PAYOVERSEASTO (state, data) {
    state.payOverseasTo = data.payOverseasTo
  },
  SET_PERSONNEL (state, data) {
    state.personnel = data.personnel
  },
  SET_PARTNERS (state, data) {
    state.partners = data.partners
  }
}

const actions = {
  checkMywarehouses ({ commit, state }, payload) {
    if (state.mywarehouses.length > 0) return Promise.resolve()

    return http.post(apiUrl.warehouse_list).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_MYWAREHOUSES', { mywarehouses: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Return:checkMywarehouses:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  },
  checkMywarehousesAdded ({ commit, state }, payload) {
    if (state.mywarehousesAdded.length > 0) return Promise.resolve()

    return http.post(apiUrl.warehouse_list).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_MYWAREHOUSESADDED', { mywarehousesAdded: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Return:checkMywarehousesAdded:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  },
  checkMywarehousesStock ({ commit, state }, payload) {
    if (state.mywarehousesStock.length > 0) return Promise.resolve()

    return http.post(apiUrl.warehouse_list).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_MYWAREHOUSESSTOCK', { mywarehousesStock: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Return:checkMywarehousesStock:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  },
  checkBillTo ({ commit, state }, payload) {
    if (state.billTo.length > 0) return Promise.resolve()

    return http.post(apiUrl.bill_to_list).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_BILLTO', { billTo: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Return:checkBillTo:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  },
  checkBillToAdded ({ commit, state }, payload) {
    if (state.billToAdded.length > 0) return Promise.resolve()

    return http.post(apiUrl.bill_to_list).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_BILLTOADDED', { billToAdded: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Return:checkBillToAdded:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  },
  checkBillToNewreturn ({ commit, state }, payload) {
    if (state.billToNewreturn.length > 0) return Promise.resolve()

    return http.post(apiUrl.bill_to_list).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_BILLTONEWRETURN', { billToNewreturn: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Return:checkBillToNewreturn:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  },
  checkPayTo ({ commit, state }, payload) {
    if (state.payTo.length > 0) return Promise.resolve()

    return http.post(apiUrl.purchase_partners_list).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_PAYTO', { payTo: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Return:checkPayTo:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  },
  checkPayOverseasTo ({ commit, state }, payload) {
    if (state.payOverseasTo.length > 0) return Promise.resolve()

    return http.post(apiUrl.purchase_partners_overseas_list).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_PAYOVERSEASTO', { payOverseasTo: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Return:checkPayOverSeasTo:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  },
  checkPersonnel ({ commit, state }, payload) {
    if (state.personnel.length > 0) return Promise.resolve()

    return http.post(apiUrl.discard_personnel).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_PERSONNEL', { personnel: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Return:checkPersonnel:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  },
  checkPartners ({ commit, state }, payload) {
    if (state.partners.length > 0) return Promise.resolve()

    return http.post(apiUrl.discard_partners).then(response => {
      const result = response.data
      if (result.status === true) {
        return commit('SET_PARTNERS', { partners: result.list })
      } else {
        return Promise.reject(new Error(result.message))
      }
    }).catch(function (error) {
      console.log('Return:checkPartner:catch(error): ', error)
      return Promise.reject(new Error('エラーのため失敗しました。ご確認後、再試行してください。'))
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
